import { render, staticRenderFns } from "./ShareIndex.vue?vue&type=template&id=367556d9&scoped=true&"
import script from "./ShareIndex.vue?vue&type=script&lang=js&"
export * from "./ShareIndex.vue?vue&type=script&lang=js&"
import style0 from "./ShareIndex.vue?vue&type=style&index=0&id=367556d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367556d9",
  null
  
)

export default component.exports